module.exports = __webpack_public_path__ + "img/spiro.5489ae0e.png";